import { removeSingleTextFilter, resetSimilarityFilters } from '../legacy/singleTextFilter';
import { emitSearchAssetsEvent } from './emitSearchAssetsEvent';
import type { SearchParams } from './types';

export const addSearchResultToFilterBar = (field: string, value: string, label?: string) => {
	const onFilterRemovedCallback = () => {
		window.bynder?.search?.FilterBar?.remove?.(field, value);
		window.bynder?.search?.FilterHelper?.search?.('media', {
			field,
			value,
			filterType: 'remove',
		});
	};

	window.bynder?.search?.FilterBar?.add?.(
		'',
		field,
		label || value, // label
		value, // value
		onFilterRemovedCallback,
		true,
	);
};

export const isReactAssetOverviewActive = () => !!document.querySelector('#rootAssetOverviewV3');

export const executeSearch = (
	params: SearchParams,
	metapropertyOptionLabel?: string,
	isPerformingNLSSearch?: boolean,
) => {
	const reactAssetOverviewIsActive = isReactAssetOverviewActive();
	const isInPimView = document.location.pathname.includes('/show/');

	// Don't remove this because it breaks the dashboard spotlight.
	// We don't have the asset overview there and so we need to redirect to the assets overview
	if (reactAssetOverviewIsActive && !isInPimView) {
		emitSearchAssetsEvent(params);
		addSearchResultToFilterBar(params.field, params.value, metapropertyOptionLabel);
	} else if (isPerformingNLSSearch) {
		const searchParams = new URLSearchParams(Object.entries(params));
		searchParams.delete('field');
		searchParams.delete('value');
		searchParams.delete('filterType');
		searchParams.delete('filterKey');
		const setFiltersRequestUrl = `/media/?${searchParams.toString()}`;
		document.location.href = setFiltersRequestUrl;
	} else {
		const searchParams = new URLSearchParams(Object.entries(params));
		const setFiltersRequestUrl = `/search/set/?${searchParams.toString()}`;
		document.location.href = setFiltersRequestUrl;
	}
};

export const getSearchParamsField = (
	isStickySearch: boolean,
	isMPOSearch?: boolean,
	metapropertyName?: string,
) => {
	if (isMPOSearch) {
		return `metaproperty_${metapropertyName}`;
	}

	if (isStickySearch) {
		return 'singletext';
	}

	return 'text';
};

export const resetStickySearchInAssetbank = (isNLSReset: boolean) => {
	if (isNLSReset) {
		resetSimilarityFilters();
	} else {
		removeSingleTextFilter();
	}
};
